import * as tslib_1 from "tslib";
import { AfterViewInit, ElementRef, ErrorHandler, NgZone, OnInit, Renderer2 } from '@angular/core';
import { DefaultUrlSerializer, NavigationCancel, NavigationEnd, NavigationError, NavigationStart, PRIMARY_OUTLET, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import * as Raven from 'raven-js';
import { AuthService } from './auth/auth/auth.service';
import { UserService } from './shared/user/user.service';
import { GoogleService } from './google/google.service';
import { HistoryTrackerService } from './shared/history-tracker/history-tracker.service';
import { SkinService } from './shared/skin/skin.service';
var AppComponent = /** @class */ (function () {
    function AppComponent(document, router, ngZone, renderer, _skin, _google, _auth, _userService, _history, _errorHandler) {
        var _this = this;
        this.document = document;
        this.router = router;
        this.ngZone = ngZone;
        this.renderer = renderer;
        this._skin = _skin;
        this._google = _google;
        this._auth = _auth;
        this._userService = _userService;
        this._history = _history;
        this._errorHandler = _errorHandler;
        this.showHeader = true;
        this.showFooter = true;
        this._serializer = new DefaultUrlSerializer();
        // Show spinner when navigating between routes
        this.router.events.subscribe(function (event) {
            _this._navigationInterceptor(event);
        });
    }
    AppComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_1;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // Subscribe to user info events
                        this._userService.userInfo.subscribe(function (userInfo) { return _this._onUserInfoUpdated(userInfo); });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this._auth.login()];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        this._errorHandler.handleError(e_1);
                        return [3 /*break*/, 4];
                    case 4:
                        // this._initUserEcho();
                        // Scroll back to top after navigation events
                        this.router.events.pipe(filter(function (event) { return event instanceof NavigationEnd; })).subscribe(function () {
                            _this.renderer.setProperty(_this.document.documentElement, 'scrollTop', 0);
                            _this.renderer.setProperty(_this.document.body, 'scrollTop', 0);
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    AppComponent.prototype.ngAfterViewInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Promise.all([
                            this._skin.load(),
                            this._google.init(this.googleAttributionEl.nativeElement)
                        ])];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    AppComponent.prototype._onUserInfoUpdated = function (userInfo) {
        if (userInfo) {
            // Update user info for error logging
            Raven.setUserContext({
                id: userInfo.masterCustomerId,
                username: userInfo.firstName + " " + userInfo.lastName
            });
        }
        else {
            // Clear user info in log events
            Raven.setUserContext();
        }
    };
    // Shows and hides the loading spinner during route changes
    AppComponent.prototype._navigationInterceptor = function (event) {
        var _this = this;
        if (event instanceof NavigationStart) {
            // We want to run this function outside of Angular's zone to bypass change detection
            this.ngZone.runOutsideAngular(function () {
                _this.renderer.setStyle(_this.loaderEl.nativeElement, 'display', 'block');
            });
        }
        if (event instanceof NavigationEnd) {
            this.hideSpinner();
            this._onNavigatePage(event.url);
        }
        // Set loading state to false in both of the below events to hide the spinner in case a request fails
        if (event instanceof NavigationCancel) {
            this.hideSpinner();
        }
        if (event instanceof NavigationError) {
            this.hideSpinner();
        }
    };
    /**
     * Method to run when we navigate to a different page within the app. This sets flags/overrides
     * as appropriate for the current page.
     * @param url {string} Current page URL
     * @private
     */
    AppComponent.prototype._onNavigatePage = function (url) {
        // @ts-ignore
        var $body = $('body');
        var tree = this.router.parseUrl(url);
        // Update header/footer visibility based on current route
        this.showHeader = this.shouldShowHeader(tree);
        this.showFooter = this.shouldShowFooter(tree);
        // Add or remove the full-page CSS class to the body tag, depending on whether we are on the search page.
        // The search page is designed to be a full page experience with no vertical scroll bar. However, some of
        // the analytics code adds invisible elements to the body that cause it to overflow and adds a scrollbar.
        // Adding the full-page CSS class is a workaround that sets overflow: hidden on the body, removing the
        // scroll bar.
        $body.removeClass('full-page');
        var group = tree.root.children[PRIMARY_OUTLET];
        if (group) {
            var segment = group.segments[0];
            if (segment) {
                if (segment.path === 'search') {
                    $body.addClass('full-page');
                }
            }
        }
    };
    /**
     * Returns true if the main site header should be displayed based on the provided route.
     * @param tree {UrlTree} Current route in the application
     * @return {boolean} True if the main site header should be displayed
     */
    AppComponent.prototype.shouldShowHeader = function (tree) {
        var group = tree.root.children[PRIMARY_OUTLET];
        if (group) {
            var segment = group.segments[0];
            if (segment) {
                switch (segment.path) {
                    case 'search':
                        // Suppress header on the search page
                        return false;
                    /* case 'airports':
                      // Show header on the "Airports by State" directory, but not on any of the airport detail pages.
                      const segment2 = group.segments[1];
                      return !!(segment2 && segment2.path === 'state'); */
                }
            }
        }
        return true; // Show header by default
    };
    /**
     * Returns true if the main site footer should be displayed based on the provided route.
     * @param tree {UrlTree} Current route in the application
     * @return {boolean} True if the main site footer should be displayed
     */
    AppComponent.prototype.shouldShowFooter = function (tree) {
        var group = tree.root.children[PRIMARY_OUTLET];
        if (group) {
            var segment = group.segments[0];
            if (segment) {
                switch (segment.path) {
                    case 'search':
                        // Suppress footer on the search page
                        return false;
                }
            }
        }
        return true; // Show footer by default
    };
    AppComponent.prototype.hideSpinner = function () {
        var _this = this;
        this.ngZone.runOutsideAngular(function () {
            _this.renderer.setStyle(_this.loaderEl.nativeElement, 'display', 'none');
        });
    };
    AppComponent.prototype._initUserEcho = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var ues, SSOTokenPromise, SSOToken;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        ues = {
                            host: 'aopa.userecho.com',
                            forum: '7',
                            lang: 'en',
                            no_dialog: true,
                            tab_corner_radius: 5,
                            tab_font_size: 20,
                            tab_image_hash: 'ZmVlZGJhY2s%3D',
                            tab_chat_hash: 'Y2hhdA%3D%3D',
                            tab_alignment: 'right',
                            tab_text_color: '#ffffff',
                            tab_text_shadow_color: '#00000055',
                            tab_bg_color: '#00a3e0',
                            tab_hover_color: '#f45c5c',
                            params: {}
                        };
                        if (!(this._auth.authenticated && this._auth.endUser)) return [3 /*break*/, 2];
                        SSOTokenPromise = this._userService.getUserechoInfo();
                        return [4 /*yield*/, SSOTokenPromise.then(function (result) { return result; })];
                    case 1:
                        SSOToken = _a.sent();
                        ues.params = { sso_token: SSOToken };
                        _a.label = 2;
                    case 2:
                        window['_ues'] = ues;
                        (function () {
                            var _ue = document.createElement('script');
                            _ue.type = 'text/javascript';
                            _ue.async = true;
                            _ue.src = ('https:' === document.location.protocol ? 'https://' : 'http://') + 'cdn.userecho.com/js/widget-1.4.gz.js';
                            var s = document.getElementsByTagName('script')[0];
                            s.parentNode.insertBefore(_ue, s);
                        })();
                        return [2 /*return*/];
                }
            });
        });
    };
    return AppComponent;
}());
export { AppComponent };
